import Page from 'components/layout/Page';
import PublicProfileComponent from 'components/publicProfile/PublicProfileComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { PublicManfrediteJobApplicationResume } from 'interfaces/manfredite.interface';
import { ManfrediteConfigurationPublicProfileViewsType } from 'interfaces/public-manfredite.interface';
import CvApplicationSampleManfredite from './CVApplicationTermsNotAcceptedComponent.data';
import { StyledBlurred } from './CVApplicationTermsNotAcceptedComponent.styled';
import CVApplicationsTermsModalComponent from './termsAndConditions/CVApplicationsTermsModalComponent';

type Props = {
  jobApplicationResume: PublicManfrediteJobApplicationResume;
  viewCvType: ManfrediteConfigurationPublicProfileViewsType;
  onAcceptTermsClick: () => Promise<void>;
};

const CVApplicationTermsNotAcceptedComponent: React.FC<Props> = ({
  jobApplicationResume,
  viewCvType,
  onAcceptTermsClick
}) => {
  const { t } = useI18n('cv-applications-view');
  const title = t('cvApplicationsView.termsNotAccepted.title', {
    fullName: `${jobApplicationResume.firstName} ${jobApplicationResume.lastName}`
  });
  const desc = t('cvApplicationsView.termsNotAccepted.desc');

  return (
    <>
      <Page noTopBar noFooter>
        <HeadMetadata title={title} desc={desc} />

        <StyledBlurred>
          <PublicProfileComponent
            publicManfredite={CvApplicationSampleManfredite}
            type={viewCvType}
            isDefaultView={false}
            sendVisitTrackEvent={false}
          />
        </StyledBlurred>

        <CVApplicationsTermsModalComponent
          isOpen={true}
          onAccept={onAcceptTermsClick}
          jobApplicationResume={jobApplicationResume}
        />
      </Page>
    </>
  );
};

export default CVApplicationTermsNotAcceptedComponent;
